<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        
        <el-button
          v-click.getDataOnlineAllDailyList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable ref="getDataOnlineAllDailyList"
      :tableColums='tableColums_getDataOnlineAllDailyList'
      api='getDataOnlineAllDailyList'
      xupdateapi='updateUser'
      :height="H-165" >
    </mytable> 

    <myform view.getDataOnlineAllDailyDetails='详情' @opened="form=>form.title += ' | @' + row.doadDate" >
      <div v-if='row'>
        <mytable ref="getDataOnlineProjectDailyList"
          :tableColums='tableColums_getDataOnlineProjectDailyList'
          api='getDataOnlineProjectDailyList'
          xupdateapi='updateUser'
          :height="H-165" >
        </mytable> 
      </div>
      <hide slot='doadId' />
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userId: null,
      tableColums_getDataOnlineAllDailyList: {
        $selection: false,

        doadDate: '日期',
        doadUserNum: '活跃人数',
        doadVisitorNum: '今日拜访数量',
        doadOrderNum: '订单数量',
        doadOrderMoney: '订单金额',

         $operation: [
          '操作', 200,
          `@text: 详情#success
           @click: $form("getDataOnlineAllDailyDetails",$this.row = $row),getDataOnlineProjectDailyList({dopdDate:$row.doadDate})
          `,
        ],
      },
      tableColums_getDataOnlineProjectDailyList: {
        $selection: false,

        dopdDate: '日期',
        projectName: '项目',
        dopdUserNum: '活跃人数',
        dopdVisitorNum: '今日拜访数量',
        dopdOrderNum: '订单数量',
        dopdOrderMoney: '订单金额',
      },

    };
  },

  watch: {
    
  },

  methods: {
  },

  created() {
    this.getDataOnlineAllDailyList({projectId:this.theProjectId});
  },
  mounted(){
    
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/data/DataAllDaily.vue